import { RelatedCollectionsSectionProps } from '../../types/components/collections/RelatedCollectionsSection';
import { CollectionRecommendationsResponse, CollectionResponse } from '../../types/api/CollectionsIndexTypes';
import { GenericResponse } from '../../types/api/Http';

import RelatedCollectionSliderContainer from './RelatedCollectionSlider';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { ENV } from '../../constants/environments';

const RelatedCollectionsSection: React.FC<RelatedCollectionsSectionProps> = ({
  collectionId,
}) => {
  const [recommendations, setRecommendations] = useState<CollectionRecommendationsResponse>();
  const [loading, setLoading] = useState<boolean>(false);

  const fetchRelatedCollections = async () => {
    if (loading || !!recommendations) return;
    setLoading(true);
    try {
      const result: GenericResponse<CollectionRecommendationsResponse> = await axios.get(
        `${ENV.api.baseURL.replace('v1', 'v2')}/collections/${collectionId}/recommendations`
      );
      setLoading(false);
      setRecommendations(result.data);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!collectionId) return;
    fetchRelatedCollections();
  }, [collectionId]);

  const renderSlider = (title: string, collections: Array<CollectionResponse>): React.ReactElement => {
    return (
      <div className="w-full">
        <h2 className="inter pb-[30px] text-[18px] md:text-[28px] font-semibold">{title}</h2>
        <div
          className={`${
            collections.length === 1
              ? '4k:ml-8'
              : 'xl:w-[95%] xl:ml-[20px] 2xl:w-[95%] 2xl:ml-[25px] 1920p:ml-[30px] 1920p:w-[94%] 4k:w-[96%] 4k:ml-6 ultra-wide:w-[97%] ultra-wide:ml-[35px]'
          }`}>
          <RelatedCollectionSliderContainer
            arrows={true}
            collections={collections}
          />
        </div>
      </div>
    )
  }

  if (!recommendations) return;

  return (
    <section
        className="relative py-20 pl-2 flex flex-col gap-16 sm:ml-[-10px] md:mb-[-100px] md:ml-[-20px] lg:ml-[-8px] lg:mb-[-50px] xl:pl-2 2xl:ml-[-5px] 1920p:mb-12 4k:mb-24 ultra-wide:ml-[-6px] ultra-wide:mb-48 z-0"
        cy-test-id="related-collections-section"
      >
        {renderSlider(
          'Recommended Products',
          recommendations.frequently_bought_together?.length ?
            recommendations.frequently_bought_together :
            recommendations.related_products
        )}
    </section>
  );
};

export default RelatedCollectionsSection;
